document.addEventListener('DOMContentLoaded', () => {
    const sidebar = document.querySelector('.content-wrapper__column') !== null;

    if (sidebar) document.querySelectorAll('.c-promoted-section').forEach((slider) => slider.classList.remove('no-sidebar'));
});
